import Axios from "axios";
import { protectedResources } from "../authConfig";
import { getUserEmail } from "../helpers/getUserEmail";

const URL =
  protectedResources.apiHRMobile.baseApi + "/api/v1/TimeInOut/GetUserInfo";
let tokenKey;

export async function getInfoUsers(email = '') {
  // ถ้าไม่มี email ให้ลองดึงจากแหล่งต่างๆ
  if (!email) {
    // Use the helper function to get email from various sources
    email = await getUserEmail();
  }

  // First check if we have cached data
  const cacheKey = email ? `cache_user_info_${email}` : 'cache_user_info_default';
  const cachedData = sessionStorage.getItem(cacheKey);
  
  if (cachedData) {
    const parsedData = JSON.parse(cachedData);
    // Set the local storage as well for other components that might depend on it
    localStorage.setItem("obj_user_info", cachedData);
    return parsedData;
  }
  
  // No cached data, proceed with API call
  if (sessionStorage.getItem("AccessToken") !== null) {
    tokenKey = JSON.parse(sessionStorage.getItem("AccessToken")).value;
    localStorage.setItem("AccessTokens", tokenKey);
  }
  
  const config = {
    headers: { Authorization: `Bearer ${tokenKey}` },
    params: email ? { emailOrId: email } : {}, // Only include email param if we have one
    paramsSerializer: params => {
      return Object.entries(params)
        .filter(([_, v]) => v !== undefined && v !== null && v !== '')
        .map(([key, val]) => `${encodeURIComponent(key)}=${encodeURIComponent(val)}`)
        .join('&');
    }
  };

  try {
    console.log('Sending GET request to:', URL, 'with params:', config.params);
    const response = await Axios.get(URL, config);
    console.log('API response successful:', response.status);
    
    // Check for valid JSON/object response
    if (!response.data || typeof response.data !== 'object') {
      console.error('API response is not valid JSON:', response.data);
      throw new Error('API did not return valid JSON data.');
    }
    
    // Cache the response in sessionStorage (10 minutes)
    const finalCacheKey = response.data?.email ? `cache_user_info_${response.data.email}` : cacheKey;
    sessionStorage.setItem(finalCacheKey, JSON.stringify(response.data));
    setTimeout(() => {
      sessionStorage.removeItem(finalCacheKey);
    }, 600000); // 10 minutes
    
    localStorage.setItem("obj_user_info", JSON.stringify(response.data));
    return response.data;
  } catch (error) {
    console.error('API request failed:', {
      url: URL,
      params: config.params,
      status: error?.response?.status,
      statusText: error?.response?.statusText,
      responseData: error?.response?.data
    });
    
    if (error?.response?.status === 401) {
      localStorage.removeItem("obj_user_info");
      sessionStorage.removeItem("AccessToken");
      throw new Error("Unauthorized");
    }
    
    
    throw error;
  }
}
